import React from 'react';
import styled from 'styled-components';
import { HEADER_BACKGROUND_COLOR, HEADER_TEXT_COLOR } from '../../GlobalStyles';
import {Logo} from './Logo';
import CopyrightText from '../CopyrightText';
import VersionText from '../VersionText';

const Footer: React.FC = () => {
    return (
      <FooterContainer>
        <Logo/>
        <CopyrightText />
        <VersionText />
      </FooterContainer>
    );
  };
  
  const FooterContainer = styled.footer`
    height: 40px;
    background-color: ${HEADER_BACKGROUND_COLOR};
    color: ${HEADER_TEXT_COLOR};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    position: fixed;
    bottom: 0;
    width: 100%;
  `;
  
  export default Footer;